module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-usa-map/index.js
// module id = 1366
// module chunks = 252003105885195